/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form1";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
import { useNavigate } from "react-router-dom";
import { No_Negetive_Input_regex } from "../../../../Utils/Common_regex";
import { useDispatch, useSelector } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Get_All_Catagory } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import toast, { Toaster } from "react-hot-toast";

import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";

import { Add_Strategy } from "../../../../ReduxStore/Slice/Admin/StrategySlice";

const AddStraegyNormal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const AdminToken = JSON.parse(localStorage.getItem("user_details")).token;
  const [CatagoryData, setCatagoryData] = useState({ loading: true, data: [] });
  const blockSpaceEnter = (e) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
    }
  };

  const removeSpaces = (value) => {
    return value.replace(/\s+/g, "");
  };

  const blockPasteWithSpaces = (e) => {
    const pastedText = e.clipboardData.getData("text");
    if (/\s/.test(pastedText)) {
      e.preventDefault();
    }
  };

  const indicatorList = [
    "RSI",
    "BollingerBand",
    "Supertrend",
    "Moving Average",
    "MACD",
    "Parabolic SAR",
    "Fractals",
    "Stochastic Oscillator",
    "ATR",
    "Envelopes",
  ];

  const formik = useFormik({
    initialValues: {
      strategyname: "",
      perlot: "",
      Catagory: "",
      segment: "",
      indecator: "",
      strategytester: "",
      strategy_description: "",
      starategylogo: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.strategyname) {
        errors.strategyname = valid_err.EMPTY_STRATEGY_NAME_ERR;
      }

      if (!values.strategy_description) {
        errors.strategy_description = valid_err.EMPTY_STRATEGY_DESCRIPTION_ERR;
      } else {
        const desc = values.strategy_description.trim();

        // 🔹 Minimum 100 characters check
        if (desc.length < 100) {
          errors.strategy_description =
            "Strategy description must be at least 100 characters long.";
        }

        // 🔹 Maximum 100 words check
        const wordCount = desc.split(/\s+/).length;
        // if (wordCount > 100) {
        //   errors.strategy_description =
        //     "Strategy description must not exceed 100 words.";
        // }
      }

      return errors;
    },
    onSubmit: async (values) => {
      values.strategyname = values.strategyname.replace(/\s+/g, "");
      const req = {
        strategy_name: values.strategyname,
        strategy_segment: "Crypto",
        strategy_description: values.strategy_description,
        strategy_image: values.starategylogo,
        strategy_indicator: values.indecator,
      };

      await dispatch(Add_Strategy({ req: req, token: AdminToken }))
        .unwrap()
        .then((response) => {
          if (response.status) {
            setTimeout(() => {
              navigate("/admin/strategies");
              toast.success(response.msg);
            }, 1000);
          } else {
            toast.error(response.msg);
          }
        });
    },
  });

  const fields = [
    {
      name: "strategyname",
      label: "Strategy Name",
      type: "text",
      col_size: 6,
      label_size: 6,
      onKeyDown: blockSpaceEnter,
      onPaste: blockPasteWithSpaces,
      onChange: (e, setFormData) => {
        const cleanValue = removeSpaces(
          e.target.value.replace(/[^a-zA-Z0-9]/g, "")
        );

        setFormData((prev) => ({
          ...prev,
          strategyname: cleanValue,
        }));
      },
    },

    {
      name: "indecator",
      label: "Strategy Indicator",
      type: "text",
      col_size: 6,
      label_size: 6,
      list: "indicator-list",   // 👈 dropdown attach
    },


    {
      name: "starategylogo",
      label: "Strategy Logo (Image)",
      type: "file",
      col_size: 12,
      label_size: 12
    },

    {
      name: "strategy_description",
      label: "Strategy Description",
      type: "msgbox",
      row_size: 7,
      col_size: 12,
      label_size: 12
    },
  ]


  const getservice = async () => {
    await dispatch(Get_All_Catagory())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setCatagoryData({
            loading: false,
            data: response.data,
          });
        }
      });
  };
  useEffect(() => {
    getservice();
  }, []);

  return (
    <>
      <Content
        Page_title="Add Strategy "
        button_title="Back"
        route="/admin/strategies"
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Add Strategy"
          title="addstrategy"
        />
        <datalist id="indicator-list">
          {indicatorList.map((item, index) => (
            <option key={index} value={item} />
          ))}
        </datalist>

        <ToastButton />
      </Content>
    </>
  );
};

export default AddStraegyNormal;
